/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_End_Reason_InvalidInputs */

const en_us2_workout_end_reason_invalid = /** @type {(inputs: Workout_End_Reason_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That is not a way a workout can end.`)
};

const pt_br2_workout_end_reason_invalid = /** @type {(inputs: Workout_End_Reason_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse não é um jeito válido de encerrar um treino.`)
};

const es_419_workout_end_reason_invalid = /** @type {(inputs: Workout_End_Reason_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esa no es una forma válida de terminar un entrenamiento.`)
};

const pt_pt2_workout_end_reason_invalid = /** @type {(inputs: Workout_End_Reason_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa não é uma forma válida de terminar um treino.`)
};

const fr_fr2_workout_end_reason_invalid = /** @type {(inputs: Workout_End_Reason_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce n'est pas une façon valide de terminer une séance.`)
};

const de_de2_workout_end_reason_invalid = /** @type {(inputs: Workout_End_Reason_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So kann ein Training nicht enden.`)
};

const it_it2_workout_end_reason_invalid = /** @type {(inputs: Workout_End_Reason_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo non è un modo valido di terminare un allenamento.`)
};

/**
* | output |
* | --- |
* | "That is not a way a workout can end." |
*
* @param {Workout_End_Reason_InvalidInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_end_reason_invalid = /** @type {((inputs?: Workout_End_Reason_InvalidInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_End_Reason_InvalidInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_end_reason_invalid(inputs)
	if (locale === "es-419") return es_419_workout_end_reason_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_end_reason_invalid(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_end_reason_invalid(inputs)
	if (locale === "de-DE") return de_de2_workout_end_reason_invalid(inputs)
	if (locale === "it-IT") return it_it2_workout_end_reason_invalid(inputs)
	return en_us2_workout_end_reason_invalid(inputs)
});
export { workout_end_reason_invalid as "workout.end_reason_invalid" }